import registerSduiDirectives from 'src/config/setup/directives/sdui.js'
import registerOtherDirectives from 'src/config/setup/directives/others.js'

export default function registerDirectives(app) {
  registerSduiDirectives(app)
  registerOtherDirectives(app)
}
